export const NARRATIVE_SUPPORTED_VALUATION_TYPES = [
  'DCF',
  'USER_DEFINED',
  'ANALYSTS',
] as const;
export type NarrativeSupportedValuationType =
  (typeof NARRATIVE_SUPPORTED_VALUATION_TYPES)[number];

export const isSupportedValuationType = (
  type: string
): type is NarrativeSupportedValuationType => {
  return NARRATIVE_SUPPORTED_VALUATION_TYPES.includes(
    type as NarrativeSupportedValuationType
  );
};

export const NARRATIVE_FV_MODAL_COMMUNITY_NARRATIVES_LIMIT = 10;

export const narrativeFvModalReturnPath = (
  pathname: string,
  companyId: string | null | undefined
) => {
  if (!companyId) return pathname;
  return `${pathname}?company=${companyId.toLocaleLowerCase()}`;
};
